import { bootstrapVariantApp } from '@shared/app/bootstrap';
import './theme/theme.css';
import { englishVariantConfig } from './variant';

bootstrapVariantApp(englishVariantConfig);
